export default "__VITE_ASSET__a971edfc__"